export default __webpack_public_path__ + "static/media/ach.44a7d8fa.svg";